// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "nav ul[data-v-69f192c9]{margin:20px 0;padding:0 0}nav ul li[data-v-69f192c9]{display:inline}nav ul li a[data-v-69f192c9]{margin:0 0;padding:15px 8px;cursor:pointer;text-decoration:none;color:#000}nav ul li a[data-v-69f192c9]:hover{color:#00f}.router-link-active[data-v-69f192c9]{color:#00f;font-weight:700}", ""]);
// Exports
module.exports = exports;
